import { createReducer } from '@reduxjs/toolkit'
import {
  clearGraph,
  removeGraphEdge,
  removeGraphEdges,
  removeGraphNode,
  removeGraphNodes,
  setDevtoolsEnabled,
  setGraphGroups,
  setGraphNodes,
  updateIsAbstract,
  updateGraphGroups,
  updateGraphNodes,
  setNodeLimit
} from 'Actions/graph'

const initialState = {
  colorPickerProps: undefined,
  devtoolsEnabled: true,
  graphData: {
    abstract: false,
    nodes: {},
    edges: {},
    groups: {
      "undefined": { color: '#EEEEEE' }
    }
  },
  nodeLimit: 5000
}

export default createReducer(initialState, {
  [clearGraph]: (state, action) => {
    state.graphData = {
      ...initialState.graphData,
      groups: state.graphData.groups,
    }
  },
  [removeGraphEdge]: (state, action) => {
    delete state.graphData.edges[action.payload]
  },
  [removeGraphEdges]: (state, action) => {
    action.payload.map((key) => { delete state.graphData.edges[key] })
  },
  [removeGraphNode]: (state, action) => {
    delete state.graphData.nodes[action.payload]
  },
  [removeGraphNodes]: (state, action) => {
    action.payload.map((id) => { delete state.graphData.nodes[id] })
  },
  [setDevtoolsEnabled]: (state, action) => {
    state.devtoolsEnabled = action.payload
  },
  [updateIsAbstract]: (state, action) => {
    state.graphData.abstract = action.payload
  },
  [updateGraphGroups]: (state, action) => {
    state.graphData.groups = {
      ...state.graphData.groups,
      ...action.payload.groups
    }
  },
  [setGraphGroups]: (state, action) => {
    state.graphData.groups = action.payload
  },
  [setGraphNodes]: (state, action) => {
    state.graphData.nodes = action.payload.nodes
    state.graphData.edges = action.payload.edges
  },
  [updateGraphNodes]: (state, action) => {
    state.graphData.nodes = {
      ...state.graphData.nodes,
      ...action.payload.nodes
    }
    state.graphData.edges = {
      ...state.graphData.edges,
      ...action.payload.edges
    }
  },
  [setNodeLimit]: (state, action) => {
    state.nodeLimit = action.payload
  }
})
